import { MyReferenceInput } from "../ra-lb-tools/components/myReference";
import { formatLockerStatus } from "../utils/formatLockerStatus";

export const LockerStatusInput = ({ verbose, ...props }) => {
  return (
    <MyReferenceInput
      reference="locker-statuses"
      can={{ resource: "locker-statuses", action: "read_all" }}
      formatLabel={(label, record) => formatLockerStatus(record, verbose).name}
      {...props}
    />
  );
};
